<template>
  <div
    class="d-flex m-0 h-100"
    :class="{ 'overflow-auto expanded': isExpanded }"
    style="border-left: 1px solid var(--border-color)"
  >
    <div v-if="isExpanded" class="d-flex w-100 flex-column h-100" style="_height: 100vh; _overflow-y: auto">
      <div class="ml-auto mt-3 px-3">
        <div class="d-flex align-items-center btn-circle">
          <a href="javascript:void(0);" @click="$emit('toggle')">
            <font-awesome-icon
              :icon="['far', 'angle-right']"
              size="lg"
              style="color: var(--muted-color); opacity: 1"
              class="_text-hint"
            />
          </a>
        </div>
      </div>
      <div class="px-3 mb-3">
        <div class="p-3 px-4" style="background: var(--border-color); border-radius: 8px">
          <h5>Did you know?</h5>
          {{
            referral.is_incoming
              ? 'Calling a patient within an hour of their visit improves conversion by 40%'
              : 'Sending a referral on Refera increases production by 30%'
          }}
        </div>
      </div>
      <!-- <div class="p-3">
        <div class="progress">
          <div class="progress-bar w-0" :class="'w-' + step * 25" role="progressbar" :aria-valuenow="step" aria-valuemin="0" aria-valuemax="4"></div>
        </div>
        <div class="progress-widget border  bg-white p-3  d-block" style="height: auto">
          <h6>Progress</h6>
          <div class="mt-3" style>
            <div class=" row status-row d-flex align-items-center">
              <div class="col">
                <span class="">Viewed</span>
              </div>
              <div class="col-3">
                <font-awesome-icon :icon="['fas', 'check-circle']" size="lg" :class="step>0 ?'text-primary':'text-hint'" />
              </div>
            </div>
            <div class="row status-row d-flex align-items-center">
              <div class="col">
                <span class="">Contacted</span>
              </div>
              <div class="col-3">
                <font-awesome-icon :icon="['fas', 'check-circle']" size="lg" :class="step>1 ?'text-primary':'text-hint'" />
              </div>
            </div>
            <div class="row status-row d-flex align-items-center">
              <div class="col">
                <span class="">Scheduled</span>
              </div>
              <div class="col-3">
                <font-awesome-icon :icon="['fas', 'check-circle']" size="lg" :class="step>2 ?'text-primary':'text-hint'" />
              </div>
            </div>
            <div class="row status-row d-flex align-items-center">
              <div class="col">
                <span class="">Treatment</span>
              </div>
              <div class="col-3">
                <font-awesome-icon :icon="['fas', 'check-circle']" size="lg" :class="step>3 ?'text-primary':'text-hint'" />
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <ReferralRightWidget title="Your schedule" @filter="$refs.appPicker.update()" :filters="['Appointments', 'Search']" v-if="isIntegrationWidgetVisible">
        <template v-slot:body_0>
          <div class="px-2">
            <appointment-picker ref="appPicker" @patientSelected="patientSelected" :vertical="true" :height="'300px'" :hideButtons="true" />
          </div>
        </template>
        <template v-slot:body_1>
          <patient-search-results ref="searchPmsInput" @close="isSearchPmsVisible = false" @patientSelected="patientSelected" />
        </template>
      </ReferralRightWidget> -->
      <referral-notes :item="referral" class="flex-grow-1 d-flex flex-column mt-auto" />
    </div>
    <div v-else class="collapsed bg-secondary d-flex flex-column" style="min-width: 50px">
      <!-- <div class="mt-3 px-3" style>
        <div class=" status-row d-flex align-items-center">

          <font-awesome-icon :icon="['far', 'eye']" size="lg" :class="referral.sent_time ?'text-primary':'text-hint'" />

        </div>
        <div class="status-row d-flex align-items-center">
          <font-awesome-icon :icon="['fas', 'phone']" size="lg" :class="referral.sent_time ?'text-primary':'text-hint'" />

        </div>
        <div class=" status-row d-flex align-items-center">

          <font-awesome-icon :icon="['far', 'calendar']" size="lg" :class="referral.is_marked_scheduled ?'text-primary':'text-hint'" />
        </div>

        <div class=" status-row d-flex align-items-center">

          <font-awesome-icon :icon="['far', 'file-medical']" size="lg" :class="referral.completed_time ?'text-primary':'text-hint'" />
        </div>
      </div> -->
      <div class="mx-auto mt-3 px-3" v-if="isExpandable">
        <div class="d-flex align-items-center _btn-circle">
          <a href="javascript:void(0);" @click="$emit('toggle')">
            <font-awesome-icon
              :icon="['far', 'angle-left']"
              size="lg"
              style="color: var(--border-color)"
              class="text-muted"
            />
          </a>
        </div>
      </div>
      <div class="mx-auto mt-5 px-3" v-if="referral.sent_time" v-tooltip.left="'View Notes &amp; Activity'">
        <div class="d-flex align-items-center hover-primary">
          <a href="javascript:void(0);" @click="$emit('toggle')">
            <font-awesome-layers full-width class="fa-lg" pulse>
              <font-awesome-icon :icon="['far', 'comment-alt']" style="color: var(--border-color)" class="fa-badge" />

              <font-awesome-layers-text v-if="isUnreadNotes" counter position="bottom-right" />
            </font-awesome-layers>
          </a>
        </div>
      </div>
      <!-- <div class="flex-grow-1 d-flex">
        <div class="mx-auto my-auto px-3" style="cursor:pointer" @click="$emit('toggle')" v-if="referral.sent_time">
          <ul class="v-progress">
            <li>
              <div class="node tt tt-left" :class="{'green':step>0, 'activated': step==1 }" aria-label="Viewed"></div>
            </li>
            <li>
              <div class="divider" :class="{'green':step>1 }"></div>
            </li>
            <li>
              <div class="node" :class="{'green':step>1, 'activated': step==2 }" title="Patient contacted"></div>
            </li>
            <li>
              <div class="divider" :class="{'green':step>2 }"></div>
            </li>
            <li>
              <div class="node" :class="{'green':step>2, 'activated': step==3 }" title="Treatment scheduled"></div>
            </li>
            <li>
              <div class="divider" :class="{'green':step>3}"></div>
            </li>
            <li>
              <div class="node" :class="{'green':step>3, 'activated': step==4 }" title="Op report complete"></div>
            </li>
          </ul>
        </div>
      </div> -->
      <!-- <div class="flex-grow-1"></div> -->
      <div
        class="mt-auto mb-3 d-flex flex-column justify-content-center align-items-center"
        :style="`margin-bottom: ${$store.getters['sms/isVisible'] ? '100px!important' : 'inherit'}`"
      >
        <div v-if="isSnoozable" class="w-100 text-center hover-primary" v-tooltip.left="'Archive referral'">
          <font-awesome-icon
            @click="isArchiveModalVisible = true"
            class="text-hint hover-primary"
            size="lg"
            :icon="['far', 'clock']"
            title="Archive Referral"
          />
        </div>
        <div v-if="!referral.sent_time" class="w-100 text-center hover-primary mt-3" v-tooltip.left="'Delete referral'">
          <font-awesome-icon
            @click="deleteReferral"
            class="text-hint hover-primary"
            size="lg"
            :icon="['far', 'trash']"
            title="Delete Referral"
          />
        </div>
        <div class="w-100 text-center hover-primary mt-3" v-tooltip.left="'Copy referral'">
          <font-awesome-icon
            @click="withPremium(() => (isCloneMondalVisible = true))"
            class="text-hint hover-primary"
            size="lg"
            :icon="['far', 'clone']"
            title="Copy Referral"
          />
        </div>
        <div class="w-100 text-center hover-primary mt-3" v-tooltip.left="'Print referral'">
          <router-link
            v-if="true || isPremium || !referral.is_incoming"
            class="hover-primary"
            :to="'/referral/print/' + referral.id"
            title="Print Referral"
            target="_blank"
          >
            <font-awesome-icon class="text-hint" size="lg" :icon="['far', 'print']" />
          </router-link>
          <font-awesome-icon
            v-else
            @click.prevent="withPremium"
            class="text-hint hover-primary"
            size="lg"
            :icon="['far', 'print']"
            v-tooltip.left="'Print referral'"
          />
        </div>
        <div
          class="hover-primary mt-3 w-100 text-center"
          @click="downloadPdf"
          title="Download Referral"
          :disabled="isDownloadingPdf"
          v-tooltip.left="'Download referral'"
        >
          <font-awesome-icon size="lg" icon="spinner-third" class="text-primary" spin v-if="isDownloadingPdf" />
          <template v-else>
            <font-awesome-icon size="lg" :icon="['far', 'download']" class="text-hint" />
          </template>
        </div>
      </div>
    </div>
    <clone-modal v-if="isCloneMondalVisible" :referralId="referralId" @close="isCloneMondalVisible = false" />
    <archive-modal
      v-if="isArchiveModalVisible"
      :isSnooze="true"
      :referralId="referralId"
      @close="isArchiveModalVisible = false"
    />
  </div>
</template>
<script>
import moment from 'moment'
import AppointmentPicker from '@/components/referrals/integration/AppointmentPicker'
import PatientSearch from '@/components/referrals/integration/PatientSearch'
import PatientSearchResults from '@/components/referrals/integration/PatientSearchResults'
import { mapGetters, mapState } from 'vuex'
import Status from '@/components/referrals/Status.vue'
import ReferralRightWidget from '@/components/referrals/rightbar/ReferralRightWidget.vue'
import ReferralNotes from '@/components/referrals/rightbar/ReferralNotes.vue'
import ReferralNote from '@/components/referrals/rightbar/ReferralNote.vue'
import client from '@/http-client'
import Indicator from '../inbox/Indicator.vue'
import { ReferralApi } from '@/services'
import CloneModal from '@/components/shared/CloneModal.vue'
import ProUpsell from '@/components/shared/ProUpsell'
import ArchiveModal from '../../modals/ArchiveModal.vue'
import { is_needs_action } from '@/store/modules/referrals'

export default {
  components: {
    AppointmentPicker,
    PatientSearch,
    PatientSearchResults,
    Status,
    ReferralRightWidget,
    ReferralNotes,
    ReferralNote,
    Indicator,
    CloneModal,
    ProUpsell,
    ArchiveModal,
  },
  props: ['referralId', 'isIntegrationWidgetVisible', 'isExpanded', 'isExpandable'],
  created() {},
  mounted() {
    const noteList = this.$refs?.noteList

    if (noteList) {
      // this.$nextTick(() => {
      //   noteList.children[noteList.children.length - 1].scrollIntoView({
      //     behavior: 'smooth',
      //   })
      // })
    }
  },
  data() {
    return {
      isLoading: true,
      isAddingNote: false,
      noteText: '',
      isSearchPmsVisible: false,
      noteFilter: 'All',
      isDownloadingPdf: false,
      isCloneMondalVisible: false,
      isArchiveModalVisible: false,
    }
  },
  computed: {
    ...mapState('referrals', {
      referralLoadError: 'error',
      isReferralsLoaded: 'isLoaded',
    }),
    ...mapState('practices', {
      isPracticesLoaded: 'isLoaded',
    }),
    ...mapGetters('auth', ['isIntegrationActive', 'user']),
    ...mapState('tour', ['activeTour', 'currentMockReferral']),
    ...mapGetters('tour', ['currentTarget']),
    ...mapGetters('referrals', ['get', 'unreadNotes']),
    referral() {
      return this.get(this.referralId)
    },
    isUnreadNotes() {
      return !!this.unreadNotes(this.referralId).length
    },
    isPremium() {
      return this.$store.getters['billing/isPremium']
    },
    isSchedulable() {
      return this.$helpers.isSchedulable(this.referral) && !this.referral.scheduled_time
    },
    historyItems() {
      return this.referral.history
        .filter(
          (s) =>
            this.noteFilter == 'All' ||
            (this.noteFilter == 'Notes' && s.type == 'CUSTOM') ||
            (this.noteFilter == 'Activity' && s.type == 'SYSTEM')
        )
        .slice()
        .reverse()
    },
    step() {
      if (this.referral.completed_time) return 3
      if (this.referral.is_marked_scheduled) return 2
      // if (this.referral.patient_called_on) return 2
      if (this.referral.receiver_viewed_at_time) return 1
      return 0
    },
    isSnoozable() {
      return (
        this.referral.sent_time &&
        this.referral.is_incoming &&
        (is_needs_action(this.referral) || this.$helpers.isArchived(this.referral))
      )
      //todo: needs_Action filter, need to consider cases like:
      //referral is in needs_Action due to "requires follow-up"
      //referral is marked snoozed with the intent it should surface to needs_action after N[>3] days
      //N[>3] days pass and it is unsnoozed but now in "all"
    },
  },
  watch: {
    isIntegrationWidgetVisibile(n) {
      if (n) {
        this.$refs.appPicker.update()
      }
    },
    isExpanded(v) {
      if (v) {
        this.$store.dispatch('referrals/readNotes', this.referral.id)
      }
    },
  },
  methods: {
    async addNote() {
      const details = this.noteText
      if (!details) return
      this.isAddingNote = true
      this.$nextTick(() => {
        this.$refs.addNotePlaceholder.$el.scrollIntoView({
          block: 'end',
          behavior: 'smooth',
        })
      })
      try {
        this.noteText = ''
        const response = await ReferralApi.saveRelated(this.referralId, 'history', {
          details,
          referral_id: this.referralId,
        })

        if (!this.referral.history.find((r) => r.id == response.id)) this.referral.history.push(response)
      } catch (e) {
        this.$exception(e)
      }
      this.isAddingNote = false
    },

    async patientSelectedFreemium(patient, event) {
      if (this.activeTour) {
        event?.stopPropagation()
        event?.stopImmediatePropagation()
        this.patientSelected(patient)
        return
      }
      // this.$gtag.event('integrationPreviewClick', { event_category: 'Upsell' })
      return
    },
    async downloadPdf() {
      this.isDownloadingPdf = true
      try {
        this.$track('$referralPdfDownload')
        const response = await client.get(`${process.env.VUE_APP_API_BASE_URL}/api/referrals/${this.referralId}/pdf`)
        if (!response.ok) throw new Error('Failed to generate PDF. Error: ' + response.status)
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `Refera_Referral_${this.referral.patient_firstname || ''}_${
          this.referral.patient_lastname?.[0] || ''
        }_${moment().format('YYYY-MM-DD')}_${this.referralId}.pdf`
          .replace('___', '_')
          .replace('__', '_')
        document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click()
        a.remove()
      } catch (err) {
        this.$helpers.error((err && err.message) || 'Failed to create PDF')
      }
      this.isDownloadingPdf = false
    },
    noteFilterChange(filter) {
      this.noteFilter = filter
    },
    patientSelected(patient) {
      const map = {
        patient_internal_id_sender: !patient ? '' : patient.id,
        patient_firstname: !patient ? '' : patient.firstname,
        patient_middlename: !patient ? '' : patient.middlename,
        patient_lastname: !patient ? '' : patient.lastname,
        patient_phone: !patient ? '' : patient.phone,
        patient_email: !patient ? '' : patient.email,
        patient_dob: !patient ? undefined : patient.birthdate,
        guardian_name: !patient ? '' : patient.guardian,
        patient_insurance_network: !patient ? '' : patient.primary_insurance_network,
        patient_insurance_subscriber: !patient ? '' : patient.primary_insurance_subscriber,
        patient_insurance_membership: !patient ? '' : patient.primary_insurance_membership,
        patient_insurance_network_secondary: !patient ? '' : patient.secondary_insurance,
        insurance_information: (patient && patient.primary_insurance_network && 'providedbelow') || 'noinsurance',
        preferred_contact_method: 'any', // !patient          ? ''          : patient.phone && patient.email          ? 'any'          : patient.phone          ? 'phone'          : patient.email          ? 'email'          : '',
      }
      Object.keys(map).map((k) => {
        this.$emit(this.referral, k, map[k] || null)
        // this.$nextTick(() => {
        //   const scope = this.$options.scope || 'referral-form'
        //   const _field = this.$validator.fields.find({
        //     name: k,
        //     scope: scope,
        //   })
        //   // debugger
        //   // if (_field)
        //   //   _field.setFlags({ touched: true, dirty: true, validated: false })
        // })
      })
      this.isOptionalPatientDataVisible = !!patient
      // this.$validator.validate('referral-form.*')
    },
    deleteReferral() {
      let body = 'Are you sure you want to delete this referral?'
      this.$dialog
        .confirm({ title: 'Confirm Delete', body }, { okText: 'DELETE', cancelText: 'No', customClass: 'dialog-warn' })
        .then(() => {
          this.$store.dispatch('referrals/delete', this.referralId)
          this.$track('$referralDelete')
          this.$router.replace('/')
        })
    },
  },
}
</script>
<style scoped lang="scss">
.status-row {
  color: var(--body-color);
  span {
    font-size: 0.875rem;
    font-weight: bold;

    // font-size: 14px;
    font-style: inherit;
    line-height: 1.14286;
    letter-spacing: -0.003em;
    color: rgb(23, 43, 77);
    font-weight: 500;
    margin-top: 0px;
  }
}
.progress {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  height: 0.5rem;
}
.progress-widget {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  h6 {
    font-size: 1rem;
  }
  .status-row {
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
}

.v-progress {
  padding: 0;

  .node {
    height: 12px;
    width: 12px;
    border-radius: 50%;
    display: block;
    transition: all 1000ms ease;
    margin: 0 auto;
    background-color: var(--border-color);
    opacity: 0.35;
  }
  .activated {
    box-shadow: 0px 0px 3px 2px var(--info-color);
  }

  .divider {
    height: 25px;
    width: 2px;
    margin-left: calc(50% - 1px);
    transition: all 800ms ease;
    border: none;
    background-color: var(--border-color);
    opacity: 0.35;
  }

  li {
    list-style: none;
    line-height: 1px;
  }

  .green {
    background-color: var(--primary-color);
    opacity: 1;
  }
  .grey {
    background-color: var(--border-color);
    opacity: 0.35;
    // box-shadow: 0px 0px 3px 2px rgba(168, 168, 168, 0.8);
  }
}
.hover-primary:hover {
  color: var(--primary-color);
  cursor: pointer;
  path {
    fill: var(--primary-color);
  }
}
.btn-circle {
  position: absolute;
  right: calc(50px - 18px);
  box-shadow: -1px 1px 14px 0px #012b302b;
  text-align: center;
  // border: 1px solid var(--border-color);
  a {
    flex: 1;
  }

  &:hover {
    // background: var(--secondary-color) !important;
    color: var(--secondary-color) !important;
    box-shadow: 1px -1px 14px 0px #012b302b;
    path {
      fill: var(--secondary-color);
    }
  }
}
.expanded .btn-circle {
  right: calc(350px + 0.5rem);
  box-shadow: none;
  z-index: 999;
  &:hover {
    box-shadow: 1px -1px 14px 0px #012b302b;
  }
}
</style>
